import React from 'react';
import { useTranslation } from 'react-i18next';

import { useModals } from 'hooks';

import ContactUsLink from 'components/ContactUsLink';
import { Box, Button, Image, Text } from 'components/library';
import Modal from 'components/Modal/Modal';

import alertImage from './img/alert.svg';

const AccountDeleteErrorContainer = () => {
    const { t } = useTranslation();
    const { closeModal } = useModals();

    return (
        <Modal isOpen onClose={closeModal}>
            <Box $paddingTop={20} $paddingBottom={20} $paddingX={16}>
                <Image center maxWidth={46} src={alertImage} alt="sandClock" mb={12} />
                <Text type="h5" bold center mb={24}>
                    {t('account.settings.deleteAccount.successModal.title')}
                </Text>
                <Text type="medium-text" center mb={24}>
                    {t('account.settings.deleteAccount.successModal.subTitle')}
                </Text>
                <a href={import.meta.env.VITE_WALKFIT_ONBOARDING}>
                    <Button onClick={closeModal} mb={20} dataLocator="obTakeQiuz">
                        {t('account.settings.deleteAccount.successModal.takeQuiz')}
                    </Button>
                </a>
                <ContactUsLink />
            </Box>
        </Modal>
    );
};

export default AccountDeleteErrorContainer;
